import * as z from 'zod'


export const rollSchema = z.object({
  id: z.string().optional().nullable(),
  rollNumber: z.union([z.string(), z.number()]).transform(val => Number(val)),
  bay: z.string().optional().nullable(),
  lengthValue: z.union([z.string(), z.number()]).transform(val => Number(val)),
  lengthUnit: z.number(),
  weight: z.union([z.string(), z.number()]).transform(val => Number(val)),
  batchId: z.string().optional().nullable(),
  returnedRollId: z.string().optional().nullable(),
  rollState: z.number().optional(),
  dateKnitted: z.string().or(z.date()).optional(),
  isActive: z.boolean().default(true),
  knittingQualityId: z.string().optional().nullable(),
  finishingQualityId: z.string().optional().nullable(),
  lastEditedBy: z.string().optional().nullable()
})

export const sendToSupplierSchema = z.object({
  batchId: z.string(),
  supplierId: z.string(),
  supplierName: z.string(),
  supplierAddressId: z.string(),
  purchaseOrderReference: z.string(),
  rollStatus: z.number(),
  packingListReference: z.string(),
  qualityId: z.string(),
  rolls: z
    .object({
      rollId: z.string()
    })
    .array(),
  notes: z.string(),
  isActive: z.boolean().default(true)
})
